import { Dialog, Stack, Text, Box, Button } from "@origin-digital/ods-core";
import React from "react";
import { DeleteDraftDialogProps } from "./types";
import { useDeleteDraftDialogContext } from "./context";

export const DeleteDraftDialog = ({
  onDeleteDraft,
}: DeleteDraftDialogProps) => {
  const { closeDialog, id } = useDeleteDraftDialogContext();
  const onDelete = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onDeleteDraft();
    closeDialog();
  };

  return (
    <Dialog
      id={id}
      open={true}
      title="Are you sure?"
      hideClose={false}
      onClose={() => closeDialog()}
    >
      <Stack space="small">
        {/* Content */}
        <Stack space="medium">
          <Text>Once you delete a draft, you can’t undo it.</Text>
        </Stack>

        {/* End Content */}

        {/* Actions */}
        <Box
          position={{
            lg: "static",
            xs: "fixed",
          }}
          paddingTop={{
            lg: "medium",
            xs: "medium",
          }}
          paddingBottom={{
            lg: "none",
            xs: "large",
          }}
          paddingX={{
            lg: "none",
            xs: "medium",
          }}
          backgroundColor="white"
          width="full"
          style={{
            left: "0",
            bottom: "0",
            zIndex: "1",
          }}
        >
          <Box
            display="flex"
            flex-wrap={{
              lg: "noWrap",
              xs: "wrap",
            }}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Box marginRight="large">
              <Button variant="text" onClick={() => closeDialog()}>
                Cancel
              </Button>
            </Box>
            <Button onClick={(e) => onDelete(e)}>Delete draft</Button>
          </Box>
        </Box>
        {/* End Actions */}
      </Stack>
    </Dialog>
  );
};
